export default __webpack_public_path__ + "static/media/consol-3-ar.9a3d0176.svg";